import { useEffect, useState } from 'react'
import { apiJson } from '../../lib/api'
import { BilingualField, Field, ui } from './shared'

type Row = {
  referente: string; phone: string; email: string;
  spotify_url: string; instagram_url: string; youtube_url: string;
  booking_note_it: string; booking_note_en: string;
}

const empty: Row = {
  referente: '', phone: '', email: '',
  spotify_url: '', instagram_url: '', youtube_url: '',
  booking_note_it: '', booking_note_en: '',
}

export function ContattiEditor() {
  const [row, setRow] = useState<Row>(empty)
  const [loading, setLoading] = useState(true)
  const [busy, setBusy] = useState(false)
  const [msg, setMsg] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    apiJson<{ contatti: Row | null }>('/api/admin/contatti')
      .then((r) => setRow({ ...empty, ...(r.contatti ?? {}) }))
      .catch((e) => setError(String(e)))
      .finally(() => setLoading(false))
  }, [])

  async function save() {
    setError(null); setMsg(null); setBusy(true)
    try {
      await apiJson('/api/admin/contatti', { method: 'PUT', body: JSON.stringify(row) })
      setMsg('Salvato.')
    } catch (err) { setError(String(err)) }
    finally { setBusy(false) }
  }

  if (loading) return <div style={{ color: 'var(--fg-muted)' }}>Carico…</div>

  return (
    <div>
      <h1 style={ui.sectionTitle}>Contatti</h1>
      <div style={{ ...ui.card, display: 'flex', flexDirection: 'column', gap: 18 }}>
        <Field label="Referente (nome)">
          <input style={ui.input} value={row.referente} onChange={(e) => setRow({ ...row, referente: e.target.value })} />
        </Field>
        <Field label="Email">
          <input style={ui.input} value={row.email} onChange={(e) => setRow({ ...row, email: e.target.value })} />
        </Field>
        <Field label="Telefono">
          <input style={ui.input} value={row.phone} onChange={(e) => setRow({ ...row, phone: e.target.value })} />
        </Field>
        <Field label="Spotify URL">
          <input style={ui.input} value={row.spotify_url} onChange={(e) => setRow({ ...row, spotify_url: e.target.value })} />
        </Field>
        <Field label="Instagram URL">
          <input style={ui.input} value={row.instagram_url} onChange={(e) => setRow({ ...row, instagram_url: e.target.value })} />
        </Field>
        <Field label="YouTube URL">
          <input style={ui.input} value={row.youtube_url} onChange={(e) => setRow({ ...row, youtube_url: e.target.value })} />
        </Field>
        <BilingualField label="Nota booking"
          valueIt={row.booking_note_it} valueEn={row.booking_note_en}
          onItChange={(v) => setRow({ ...row, booking_note_it: v })}
          onEnChange={(v) => setRow({ ...row, booking_note_en: v })}
          multiline />

        <div style={{ display: 'flex', gap: 8 }}>
          <button type="button" style={ui.btn} disabled={busy} onClick={save}>{busy ? '…' : 'Salva'}</button>
          {msg && <span style={{ alignSelf: 'center', color: 'var(--fg-soft)', fontSize: 13 }}>{msg}</span>}
          {error && <span style={{ alignSelf: 'center', color: '#a33' }}>{error}</span>}
        </div>
      </div>
    </div>
  )
}
